import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScheduleSendIcon(props: IconProps) {
    return <Icon {...props} iconKey={"schedule_send"}/>
}
